/**
 * Utility functions for generating meta descriptions and keywords
 */

import { KEYWORDS } from './constants';

/**
 * Generate a meta description from job description, cut at the last full sentence within 160 chars
 */
export function generateMetaDescription(description: string | null | undefined): string {
  if (!description) return '';
  
  const maxLen = 160;
  if (description.length <= maxLen) {
    return description;
  }
  
  // Find the last period within the limit
  const truncated = description.slice(0, maxLen);
  const lastPeriod = truncated.lastIndexOf('.');
  if (lastPeriod !== -1 && lastPeriod > 40) {
    return truncated.slice(0, lastPeriod + 1).trim();
  }
  
  return truncated.trim();
}

/**
 * Generate job-specific keywords from job data
 */
export function generateJobKeywords(
  locale: 'fi' | 'en' | 'sv',
  title: string | null | undefined,
  companyId: string | null | undefined,
  location: string | string[] | null | undefined,
  companyIndustry: string | null | undefined,
  specialisations: string[] | null | undefined
): string {
  const baseKeywords = KEYWORDS[locale] || KEYWORDS.en;
  
  const jobKeywords = [
    baseKeywords,
    title,
    companyId,
    Array.isArray(location) ? location.join(', ') : location,
    companyIndustry,
    specialisations && Array.isArray(specialisations) ? specialisations.join(', ') : specialisations,
  ]
    .filter(Boolean)
    .join(', ');
  
  return jobKeywords;
}
